import * as Yup from "yup";

/**
 * @description for validation of data
 * @returns Schemas for Validation
 */

import {
  emailRegExp,
  passRegrex,
  passwordError,
  phoneRegExp,
} from "./validation";

export const LoginSchema = () =>
  Yup.object().shape({
    email: Yup.string()
      .trim()
      .required("Enter the required field")
      .matches(emailRegExp, "Please enter valid Email"),
    password: Yup.string()
      .trim()
      .required("Enter the required field")
      .max(16, "Password should be maximum of 16 characters")
      .min(8, "Password should be minimum of 8 characters")
      .matches(passRegrex, passwordError),
  });

export const ResetPasswordSchema = () =>
  Yup.object().shape({
    email: Yup.string()
      .trim()
      .required("Enter the required field")
      .matches(emailRegExp, "Please enter valid Email"),
  });

export const ChangePasswordSchema = () =>
  Yup.object().shape({
    oldPassword: Yup.string()
      .trim()
      .required("Enter the required field")
      .max(16, "Password should be maximum of 16 characters")
      .min(8, "Password should be minimum of 8 characters")
      .matches(passRegrex, passwordError),
    newPassword: Yup.string()
      .trim()
      .required("Enter the required field")
      .max(16, "Password should be maximum of 16 characters")
      .min(8, "Password should be minimum of 8 characters")
      .matches(passRegrex, passwordError),
    confirmPassword: Yup.string()
      .trim()
      .required("Enter the required field")
      .oneOf(
        [Yup.ref("newPassword"), null],
        "Confirm password and New Password must match"
      ),
  });
export const SetNewPasswordSchema = () =>
  Yup.object().shape({
    newPassword: Yup.string()
      .trim()
      .required("Enter the required field")
      .max(16, "Password should be maximum of 16 characters")
      .min(8, "Password should be minimum of 8 characters")
      .matches(passRegrex, passwordError),
    confirmPassword: Yup.string()
      .trim()
      .required("Enter the required field")
      .oneOf(
        [Yup.ref("newPassword"), null],
        "Confirm password and New Password must match"
      ),
  });

export const EditProfileSchema = () =>
  Yup.object().shape({
    firstName: Yup.string()
      .trim()
      .required("Enter your first name")
      .min(2, "First name should be minimum of 2 characters")
      .max(30, "First name should be maximum of 30 characters"),
    lastName: Yup.string()
      .trim()
      .required("Enter your last name")
      .min(2, "Last name should be minimum of 2 characters")
      .max(30, "Last name should be maximum of 30 characters"),
    phoneNo: Yup.string()
      .trim()
      .required("Enter your phone number")
      .min(10, "Mobile number should be 10 digit")
      .matches(phoneRegExp, "Please enter a valid phone nubmer."),
    // profileImage:Yup.string().trim().required("Enter ")
  });

export const addSitesSchema = () =>
  Yup.object().shape({
    siteName: Yup.string()
      .trim()
      .required("Enter site name")
      .min(2, "Site name should be minimum of 2 characters")
      .max(50, "Site name should be maximum of 30 characters"),
    description: Yup.string()
      .trim()
      .required("Enter site description")
      .min(15, "Site desciption should be minimum of 15 characters")
      .max(2000, "Site desciption should be maximum of 2000 characters"),
    addressLine1: Yup.string()
      .trim()
      .required("Enter site address")
      .min(2, "Site addressLine should be minimum of 2 characters")
      .max(200, "Site addressLine should be maximum of 200 characters"),
    addressLine2: Yup.string()
      .trim()
      .required("Enter alternative site address")
      .min(2, "Site addressLine should be minimum of 2 characters")
      .max(200, "Site addressLine should be maximum of 200 characters"),
    postalCode: Yup.string()
      .trim()
      .required("Enter your postal code")
      .min(4, "Postal code should be 4 characters")
      .max(8, "Postal code should be at max 8 characters"),
    city: Yup.string()
      .trim()
      .required("Enter site city")
      .min(2, "City name should be minimum of 2 characters")
      .max(30, "City name should be maximum of 30 characters"),
    state: Yup.string()
      .trim()
      .required("Enter site state")
      .min(2, "state name should be minimum of 2 characters")
      .max(30, "state name should be maximum of 30 characters"),
    country: Yup.string()
      .trim()
      .required("Enter site country")
      .min(2, "country name should be minimum of 2 characters")
      .max(30, "country name should be maximum of 30 characters"),
    latitude: Yup.number()
      .required("Enter your latitude value")
      .max(90, "Latitude cannot exceed 90")
      .min(-90, "Latitude cannot be less than -90"),
    longitude: Yup.number()
      .required("Enter your longitude value")
      .max(180, "Longitude cannot exceed 180")
      .min(-180, "Longitude cannot be less than -180"),
    diveType: Yup.string().required("Select dive type"),
    maxDepth: Yup.number()
      .required("Enter max depth")
      .min(0, "Max depth cannot be less than 0")
      .max(11000, "Max Depth cannot exceed 11000"),
    // images: Yup.array()
    //   .min(
    //     2,
    //     "At least 2 image and video is required. default image and other site images"
    //   )
    //   .max(20, "At max you can upload 20 images")
    //   .of(
    //     Yup.mixed().test("fileType", "Unsupported file format", (value) =>
    //       ["image/jpeg", "image/png", "image/gif", "video/mp4", "video/quicktime"].includes(
    //         value?.type
    //       )
    //     )
    //   )
    //   .required("Images are required"),
  });

export const updateSitesSchema = () =>
  Yup.object().shape({
    siteName: Yup.string()
      .trim()
      .required("Enter site name")
      .min(2, "Site name should be minimum of 2 characters")
      .max(50, "Site name should be maximum of 30 characters"),
    description: Yup.string()
      .trim()
      .required("Enter site description")
      .min(15, "Site desciption should be minimum of 15 characters")
      .max(2000, "Site desciption should be maximum of 2000 characters"),
    addressLine1: Yup.string()
      .trim()
      .required("Enter site address")
      .min(2, "Site addressLine should be minimum of 2 characters")
      .max(200, "Site addressLine should be maximum of 200 characters"),
    addressLine2: Yup.string()
      .trim()
      .required("Enter alternative site address")
      .min(2, "Site addressLine should be minimum of 2 characters")
      .max(200, "Site addressLine should be maximum of 200 characters"),
    postalCode: Yup.string()
      .trim()
      .required("Enter your postal code")
      .min(4, "Postal code should be 4 digit")
      .max(8, "Postal code should be at max 8 digits"),
    city: Yup.string()
      .trim()
      .required("Enter site city")
      .min(2, "City name should be minimum of 2 characters")
      .max(30, "City name should be maximum of 30 characters"),
    state: Yup.string()
      .trim()
      .required("Enter site state")
      .min(2, "state name should be minimum of 2 characters")
      .max(30, "state name should be maximum of 30 characters"),
    country: Yup.string()
      .trim()
      .required("Enter site country")
      .min(2, "country name should be minimum of 2 characters")
      .max(30, "country name should be maximum of 30 characters"),
    latitude: Yup.number()
      .required("Enter your latitude value")
      .max(90, "Latitude cannot exceed 90")
      .min(-90, "Latitude cannot be less than -90"),
    longitude: Yup.number()
      .required("Enter your longitude value")
      .max(180, "Longitude cannot exceed 180")
      .min(-180, "Longitude cannot be less than -180"),
    diveType: Yup.string().required("Select dive type"),
    maxDepth: Yup.number()
      .required("Enter max depth")
      .min(0, "Max depth cannot be less than 0")
      .max(11000, "Max Depth cannot exceed 11000"),
    // images: Yup.array()
    //   .min(1, "At least one image is required")
    //   .max(20, "At max you can upload 20 images")
    //   .of(
    //     Yup.mixed().test("fileType", "Unsupported file format", (value) =>
    //       ["image/jpeg", "image/png", "image/gif"].includes(value?.type)
    //     )
    //   )
    //   .required("Images are required"),
  });

export const addCitySchema = () =>
  Yup.object().shape({
    postalCode: Yup.string()
      .trim()
      .required("Enter your postal code")
      .min(4, "Postal code should be 4 characters")
      .max(8, "Postal code should be at max 8 characters"),
    city: Yup.string()
      .trim()
      .required("Enter site city")
      .min(2, "City name should be minimum of 2 characters")
      .max(30, "City name should be maximum of 30 characters"),
    state: Yup.string()
      .trim()
      .required("Enter site state")
      .min(2, "state name should be minimum of 2 characters")
      .max(30, "state name should be maximum of 30 characters"),
    country: Yup.string()
      .trim()
      .required("Enter site country")
      .min(2, "country name should be minimum of 2 characters")
      .max(30, "country name should be maximum of 30 characters"),
  });
